<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <v-icon large left>mdi-wrench-clock</v-icon>
                    <h6>Capacitaciones por Prioridad</h6>
                </v-card-title>
                <v-data-table dense :headers="headers" :items="listado" :single-expand="true" locale="es-ar"
                    class="elevation-1" :items-per-page="100" hide-default-footer :loading="loadtable"
                    loading-text="Cargando... Espere por favor" no-data-text="No hay datos disponibles">
                </v-data-table>
            </v-card>
        </v-app>
    </div>
</template>
<style lang="scss" scoped>
.theme--light.v-data-table tbody tr:nth-of-type(even) {
    background-color: rgba(108, 76, 76, 0.03);
}

.theme--dark.v-data-table tbody tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, .5);
}
</style>
<script>
import axios from "../../../axios-auth";

export default {

    data: (vm) => ({
        editedItem: {},
        editedIndex: -1,
        afecta: "",
        showListado: false,
        listado: [],

        loadtable: false,
        headers: [
            {
                text: "Periodo",
                align: "start",
                sortable: false,
                value: "periodo",
                width: "10%",
            },
            {
                text: "Total",
                value: "total",
                sortable: false,
                width: "15%",
                align: "center",
            },
            {
                text: "Cantidad Prioridad A",
                value: "rectotalA",
                sortable: false,
                width: "10%",
                align: "center",
            },
            {
                text: "Porcentaje Prioridad A",
                value: "porcA",
                sortable: false,
                width: "15%",
                align: "center",
            },
            {
                text: "Cantidad Prioridad B",
                value: "rectotalB",
                sortable: false,
                width: "10%",
                align: "center",
            },
            {
                text: "Porcentaje Prioridad B",
                value: "porcB",
                sortable: false,
                width: "15%",
                align: "center",
            },
            {
                text: "Cantidad Prioridad C",
                value: "rectotalC",
                sortable: false,
                width: "10%",
                align: "center",
            },
            {
                text: "Porcentaje Prioridad C",
                value: "porcC",
                sortable: false,
                width: "15%",
                align: "center",
            },

        ],

    }),
    computed: {
        show: {
            get() {
                this.cargarListados();
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    methods: {
        cargarListados() {
            this.vaciarModels();
            this.loadtable = true;
            let self = this;

            axios
                .get("/RRHH/CargarTotalPlan?", {})
                .then((response) => {
                    self.listado = response.data;
                    self.loadtable = false;
                })
                .catch((error) => {
                    self.listado = [];
                    console.log(error);
                });
        },

        vaciarModels() {
            this.listado = [];
        },

    },
};
</script>
